import { render, staticRenderFns } from "./ClmTypeDets.vue?vue&type=template&id=d06fe8bc&"
import script from "./ClmTypeDets.vue?vue&type=script&lang=js&"
export * from "./ClmTypeDets.vue?vue&type=script&lang=js&"
import style0 from "./ClmTypeDets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClmTypeDets.vue"
export default component.exports